import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import axios from 'axios';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import api from 'core/utils/api';

const propTypes = {
  logo: PropTypes.string,
  onUploadSuccess: PropTypes.func.isRequired,
};

class AccountLogoUpload extends Component {
  drop = (accepted, rejected) => {
    let file = accepted[0];
    const { name, type } = file;

    api.put('/account/logo', {
      file: { name, type },
    }).then(res => {
      return axios.put(res.data.url, file, {
        headers: {
          'Content-Type': type,
        }
      })
    })
    .then(res => {
      this.props.onUploadSuccess();
    });
  }

  renderImg = (logo) => {
    if (logo) {
      return <img src={logo} alt="company logo" />
    } else {
      return (
        <div className="AccountLogoUpload__noPic">
          <FontAwesomeIcon icon={["far", "camera"]} />
          <i className="fa fa-camera"></i>
        </div>
      )
    }
  }

  render() {
    const { logo } = this.props;
    let dropzoneRef;

    return (
      <div className="AccountLogoUpload">
        <div className="AccountLogoUpload__img">
          {this.renderImg(logo)}
          <small className="form-text text-muted">Image ratio: 9:16</small>
        </div>
        <Dropzone
          ref={(node) => { dropzoneRef = node }}
          onDrop={(accepted, rejected) => { this.drop(accepted, rejected) }}
          multiple={false}
          accept="image/*"
          className="accountLogo"
        ></Dropzone>
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          onClick={() => { dropzoneRef.open() }}
        >
          Update Logo
        </button>
      </div>
    );
  }
}

AccountLogoUpload.propTypes = propTypes;

export default AccountLogoUpload;



// WEBPACK FOOTER //
// ./src/features/Account/accountProfile/AccountLogoUpload.js